<template lang="pug">
  #account-list
    template(v-if="isLoading === true")
      loading(:height="200")
    template(v-else)
      b-card
        b-button.mb-2(variant="primary", :disabled="isButtonDisabled", :to="{ name: 'AddAccount' }") アカウント追加
        b-form-text.my-2.align-left.text-left.error-message-color(v-for="(error_msg, error_key) of error_msg_list", :key="error_key") {{error_msg}}
        b-table.border-bottom.table-font-size.mb-2(
          head-variant="light",
          :fields="fields",
          :items="accounts",
          :tbody-tr-class="rowClass"
        )
          template(#cell(id)="data")
            .float-right(v-if="data.item.add_account_flg === '0'")
              .d-flex.justify-content-end
                b-button(v-b-modal.resend-email-modal, size="sm", variant="success", @click="setAddAccountId(data.value)", :disabled="isButtonDisabled") メール再送信
                b-button.ml-2(v-b-modal.cancel-offer-modal, size="sm", variant="danger", @click="setAddAccountId(data.value)", :disabled="isButtonDisabled") 削除
            b-button.float-right(v-else, v-b-modal.delete-modal, size="sm", variant="danger", @click="setDeleteId(data.value)", :disabled="isButtonDisabled") 削除
        b-button(variant="primary", :disabled="isButtonDisabled", :to="{ name: 'AddAccount' }") アカウント追加
        .float-right
          ul.usage-guide
            li
              span
                //- 凡例の色付き四角
                .color-sample.applying_bg_color
                .color-description.mt-1 ・・・メール確認待ち

      //- 削除確認ダイアログ
      b-modal#delete-modal(title="ご確認", ok-title="はい", cancel-title="いいえ", ok-variant="danger", @ok="deleteAccount")
        template(#modal-header-close)
          span(title="閉じる") ×
        span 選択したアカウントを削除します。
          br
          | よろしいですか？
      //- メール再送信確認ダイアログ
      b-modal#resend-email-modal(title="ご確認", ok-title="はい", cancel-title="いいえ", ok-variant="success", @ok="resendAddAccount")
        template(#modal-header-close)
          span(title="閉じる") ×
        span アカウント追加申込メールを再送信します。
          br
          | よろしいですか？
      //- アカウント追加申込削除確認ダイアログ
      b-modal#cancel-offer-modal(title="ご確認", ok-title="はい", cancel-title="いいえ", ok-variant="danger", @ok="cancelAddAccount")
        template(#modal-header-close)
          span(title="閉じる") ×
        span アカウント追加申込を削除します。
          br
          | よろしいですか？
</template>

<script>
import Api from '@/repositories/api';
import Loading from '@/components/Loading';

const S212AccountManagementRepository = Api.get('s212AccountManagement');

export default {
  name: 'AccountList',
  components: {
    Loading,
  },
  data() {
    return {
      // ローディングフラグ
      isLoading: false,

      // ボタンのdisabledフラグ
      isButtonDisabled: false,

      // 削除対象ID
      delete_id: '',

      // アカウント申込削除・メール再送信対象ID
      add_account_id: '',

      // エラーメッセージ
      error_msg_list: [],

      // テーブル項目
      fields: [
        { key: 'user_name', label: 'ユーザー名' },
        { key: 'user_mail', label: 'メールアドレス' },
        { key: 'id', label: '' }
      ],

      // アカウント一覧
      accounts: []
    }
  },
  created() {
    // ローディング開始
    this.isLoading = true

    // アカウント一覧取得API呼び出し
    S212AccountManagementRepository.view()
    .then((response) => {
      // アカウント一覧を取得
      const arAccountList = response.data.account_list;

      // 各アカウントを追加していく
      for (let key in arAccountList) {
        this.accounts.push(
          {
            id:        arAccountList[key].id,                    // ID（削除処理用）
            user_name: arAccountList[key].user_name,             // ユーザー名
            user_mail: arAccountList[key].user_mail,             // メールアドレス
            add_account_flg: arAccountList[key].add_account_flg, // アカウント追加情報フラグ
          }
        )
      }
    })
    .catch((error) => {
      // 共通のエラー処理
      this.apiError(error, '画面表示処理');
    })
    .finally(() => {
      // ローディング終了
      this.isLoading = false;
    })
  },
  methods: {
    /**
     * 削除対象ID設定
     * @param id
     */
    setDeleteId(id) {
      // 削除対象IDを設定
      this.delete_id = id;
    },
    /**
     * アカウント削除処理呼び出し
     */
    deleteAccount() {
      // ボタンをロックする
      this.isButtonDisabled = true;

      // エラーメッセージを初期化
      this.error_msg_list = [];

      // アカウント削除処理呼び出し
      S212AccountManagementRepository.delete(this.delete_id)
      // 処理成功
      .then(() => {
        this.$router.go({
          path: this.$router.currentRoute.path,
          force: true
        })
      })
      // 失敗
      .catch((error) => {
        // 共通のエラー処理
        this.apiError(error, '削除処理');

        // httpステータスコードが403の場合（権限エラー）
        if (error.response.status === 403) {
          // 画面上部にエラーメッセージを表示する
          this.error_msg_list.push(this.forbidden_message);

          // 画面一番上へスクロールする
          this.pageTopScroll();
        }

        // エラーメッセージがある場合
        if (error.response.data.error_list !== null && error.response.data.error_list !== undefined) {
          // 全てのエラーメッセージ確認
          for (let errorData of error.response.data.error_list) {
            // エラーメッセージ追加
            this.error_msg_list.push(errorData.error_msg);
          }
        }
      })
      .finally(() => {
        // ボタンのロック解除
        this.isButtonDisabled = false;
      })
    },
    /**
     * アカウント追加申込削除・メール再送信する対象のアカウント追加ID設定
     * @param id
     */
    setAddAccountId(id) {
      // 対象IDを設定
      this.add_account_id = id;
    },
    /**
     * アカウント追加申込削除処理の呼び出し
     */
    cancelAddAccount() {
      // ボタンをロックする
      this.isButtonDisabled = true;

      // エラーメッセージを初期化
      this.error_msg_list = [];

      // アカウント追加申込削除処理呼び出し
      S212AccountManagementRepository.cancel(this.add_account_id)
      // 処理成功
      .then(() => {
        // 現在のページを再読み込み
        this.$router.go({
          path:  this.$router.currentRoute.path,
          force: true
        })
      })
      // 失敗
      .catch((error) => {
        // 共通のエラー処理
        this.apiError(error, 'アカウント追加申込削除処理');

        // httpステータスコードが403の場合（権限エラー）
        if (error.response.status === 403) {
          // 画面上部にエラーメッセージを表示する
          this.error_msg_list.push(this.forbidden_message);

          // 画面一番上へスクロールする
          this.pageTopScroll();
        }

        // エラーメッセージがある場合
        if (error.response.data.error_list !== null && error.response.data.error_list !== undefined) {
          // 全てのエラーメッセージ確認
          for (let errorData of error.response.data.error_list) {
            // エラーメッセージ追加
            this.error_msg_list.push(errorData.error_msg);
          }
        }
      })
      .finally(() => {
        // ボタンのロック解除
        this.isButtonDisabled = false;
      })
    },
    /**
     * アカウント追加申込メール再送信処理の呼び出し
     */
    resendAddAccount() {
      // ボタンをロックする
      this.isButtonDisabled = true;

      // エラーメッセージを初期化
      this.error_msg_list = [];

      // アカウント追加申込メール再送信処理呼び出し
      S212AccountManagementRepository.resend(this.add_account_id)
      // 処理成功
      .then(() => {
        // 現在のページを再読み込み
        this.$router.go({
          path:  this.$router.currentRoute.path,
          force: true
        })
      })
      // 失敗
      .catch((error) => {
        // 共通のエラー処理
        this.apiError(error, 'アカウント追加申込メール再送信処理');

        // httpステータスコードが403の場合（権限エラー）
        if (error.response.status === 403) {
          // 画面上部にエラーメッセージを表示する
          this.error_msg_list.push(this.forbidden_message);

          // 画面一番上へスクロールする
          this.pageTopScroll();
        }

        // エラーメッセージがある場合
        if (error.response.data.error_list !== null && error.response.data.error_list !== undefined) {
          // 全てのエラーメッセージ確認
          for (let errorData of error.response.data.error_list) {
            // エラーメッセージ追加
            this.error_msg_list.push(errorData.error_msg);
          }
        }
      })
      .finally(() => {
        // ボタンのロック解除
        this.isButtonDisabled = false;
      })
    },
    /**
     * 行に適用するクラス設定
     */
    rowClass(item, type) {
      // アイテム行以外の場合
      if (type !== 'row') {
        // クラスなし
        return;
      }
      // アカウント追加中の場合
      if (item.add_account_flg === '0') {
        // 背景色設定
        return 'applying_bg_color'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#account-list {
  min-width: max-content;
}
.usage-guide {
  margin: 0;
  padding: 2px;
  list-style-type: none;
  overflow: hidden;

  li {
    padding-left: 1em;
    float: left;

    &:first-child {
      padding: 0;
    }

    .color-sample {
      display: inline-block;
      border: 2px solid #dee2e6;
      width: 45px;
      height: 30px;
    }
    .color-description {
      display: inline-block;
      vertical-align: top;
    }
  }
}
::v-deep .applying_bg_color {
  background-color: #e6ffe6;
}
</style>
